import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: ${props => props.$width};
    height: ${props => props.$height};
    align-items: center;
    justify-content: center;
`;
